import getPublicSettings from './getPublicSettings';

const PublicSettingsRequests = {
	getPublicSettings,
};

export default PublicSettingsRequests;
